var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crly-a-common-logo",on:{"click":_vm.clickLogo}},[_c('CMS',{attrs:{"contents_type":"block_contents","location_code":"CRLY_TOP_01_001-top_logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }